import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Tooltip,
  Box,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Select,
  Stack,
  MenuItem,
  Autocomplete,
  IconButton,
  CircularProgress,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FreightAndInsurance from "../FreightAndInsurance/FreightAndInsurance";
import LocalTaxes from "../LocalTaxes/LocalTaxes";
import DestinationCountryCost from "../DestinationCountryCost/DestinationCountryCost";
import { useDispatch, useSelector } from "react-redux";
import MapChart from "../Map/AmMap";
import { updateDropDown } from "../Redux/Reducer/CityAndPortReducer";
import BubbleChart from "../Chart/BubbleChart";
import isEqual from "fast-deep-equal";
import axiosInstance from "../Utils/AxoisClient";
import "../../App.css";
import Popup from "../Popup/Popup";
import bookmark from "../Assets/bookmark.png";
import excel from "../Assets/excel.png";
import { groupedByOrigin } from "../CountryWithNoPortData/GroupedByOrigin";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import bookmarkIcon from "../Assets/editbookmark.png";
import { updateFOB } from "../Redux/Reducer/FOBReducer";
import { updateCIF } from "../Redux/Reducer/CIFReducer";

const cardHeaderStyle = {
  color: "#FFF !imporatant",
  textAlign: "center",
  fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "normal",
  letterSpacing: "0.01em",
  // textTransform: "uppercase",
  textAlign: "center",
  background: "linear-gradient(135deg, #2C003E 0%, #592DFF 100%)",
  borderRadius: "16px 16px 0 0",
};
const tableHeaderStyle = {
  // background: "#E8EBFB",
  color: "#2C003E",
  borderRadius: "4px",
};
const cellHeader = {
  borderRadius: "4px",
  background: "#2C003E",
};
const fontStyle = {
  fontFamily: "Inter",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "normal",
  letterSpacing: "-0.387px",
};
const headerFontStyle = {
  width: "150px",
  minWidth: "250px",
  whiteSpace: "nowrap",
  padding: "2px",
  borderBottom: "none",
  color: "#2C003E",
};
const stickyStyle = {
  position: "sticky",
  left: 0,
  zIndex: 10,
  boxShadow: "4px 0px white",
};
const footerStyle = {
  display: "flex",
  justifyContent: "space-between",
  background: "#fff",
};
const buttonStyle = {
  opacity: 0.9,
  background: "#7847DC",
  position: "sticky",
  textTransform: "none",
  bottom: 0,
  borderRadius: "22px",
  height: "30px",
  margin: "4px 0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0 4px 12px rgba(120, 71, 220, 0.3)",
  transition: "box-shadow 0.15s ease, opacity 0.15s ease",
  "&:hover": {
    opacity: 1,
    boxShadow: "0 6px 16px rgba(120, 71, 220, 0.4)",
  },
};
const mapFooterStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  textAlign: "center",
  alignItems: "center",
  background: "white",
};
const footerItemMap = {
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  padding: "2px 5px",
};
const cardStyle = {
  m: 1.5,
  mr: { xs: 1.5, md: 1.5, lg: 0.75 },
  boxShadow: "0 8px 30px rgba(44, 0, 62, 0.1)",
  pb: 0,
  width: "100%",
  position: "relative",
  border: "1px solid #eef0f4",
  borderRadius: "16px",
  overflow: "hidden",
  transition: "box-shadow 0.25s ease, transform 0.25s ease",
  "&:hover": {
    boxShadow: "0 14px 40px rgba(44, 0, 62, 0.16)",
    transform: "translateY(-2px)",
  },
};

const cardBoxHeaderStyle = {
  display: "flex",
  justifyContent: "center",
  borderRadius: "16px",
  height: "410px",
};
const EditableTable = ({
  selectedMaterial,
  selectedRows,
  selectedHeader,
  selectedCity,
  selectedPort,
  selectedOriginCity,
  goButton,
  id,
  currencyList,
  from,
  selectedHSCode,
  scrollToDownRef,
  selectedSubCategory,
  timePeriodBookmark,
}) => {
  const rowHeight = 20;
  const [countryNames, setCountryNames] = useState([]);
  const [countryUpdatedNames, setCountryUpdatedNames] = useState([]);
  const [showRow, setShowRow] = useState(true);
  const FOBValues = useSelector((state) => state.FOBData.FOB);
  const isEditing = useSelector((state) => state.FOBData.loading);
  const EXWValues = useSelector((state) => state.EXWData.EXW);
  const CIFValues = useSelector((state) => state.CIFData.CIF);
  const CIFUpdateValue = useSelector((state) => state.CIFValue.CIFValue);
  const DDPValues = useSelector((state) => state.DDPData.DDP);
  const DDUValues = useSelector((state) => state.DDUData.DDU);
  const [destinationCountryData, setDestinationCountryData] = useState([]);
  const [oceanFreightData, setOceanFreightData] = useState([]);
  const [currencyRate, setCurrencyRate] = useState(1);
  const [vatData, setVatData] = useState([]);
  const generateDataObject = (countries) => {
    const createCountryObject = (country) => ({ country, value: "" });
    return {
      // loadingCharges: countries.map(createCountryObject),
      localLogistics: countries.map(createCountryObject),
      taxes: countries.map(createCountryObject),
      exportDuty: countries.map(createCountryObject),
      // customDuty: countries.map(createCountryObject),
      customClearance: countries.map(createCountryObject),
      terminalHandling: countries.map(createCountryObject),
    };
  };
  const [data, setData] = useState(generateDataObject(countryNames));
  const [tempEditData, setTempEditData] = useState({});
  const [open, setOpen] = useState(false);
  const [openUpdateBookMark, setOpenUpdateBookMark] = useState(false);
  const [freightData, setFrightData] = useState([]);
  const [destinationCountryUpdatedData, setDestinationCountryDataUpdatedData] =
    useState([]);
  const [vatUpdatedData, setVatUpdatedData] = useState([]);
  const [editable, setEditable] = useState({
    loadingCharges: false,
    localLogistics: false,
    taxes: false,
    exportDuty: false,
    customClearance: false,
    terminalHandling: false,
    exw: true,
    fob: true,
  });
  const [exwValues, setExwValues] = useState([]);
  const [fobTotals, setFobTotals] = useState(
    countryNames.reduce((acc, country) => {
      acc[country] = "";
      return acc;
    }, {}),
  );
  const [editingColumn, setEditingColumn] = useState({});
  const [apiPayload, setApiPayload] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState({
    country: "USA",
    code: "USD",
    rate: 1,
    currency_symbol: "$",
  });
  const [timePeriod, setTimePeriod] = useState([]);
  const [selectedTimePeriod, setSelectedTimePeriod] = useState("");
  const [getLatest, setGetLatest] = useState(false);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [getLatestLoading, setGetLatestLoading] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenUpdateBookmark = () => setOpenUpdateBookMark(true);
  const handleCloseUpdateBookmark = () => setOpenUpdateBookMark(false);
  const CityAndPort = useSelector((state) => state.DropDownData.DropDownData);
  const currencyListCountry = useSelector(
    (state) => state?.Currency?.currencyList,
  );

  const selectedCurrencyRedux = useSelector((state) => state?.SelectedCurrency);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const myRef = useRef(null);
  const mainViewRef = useRef(null);
  const isFirstLoad = React.useRef(true);
  const prevCurrencyRef = useRef({ code: "USD", label: "US Dollar" });

  const selectedValue = useSelector(
    (state) => state.DropDownData.DropDownData[0],
  );

  //get time period list — scoped to the current material/HS code/currency/
  // country selection so the quarter dropdown only offers periods that
  // actually have data for this combination.
  React.useEffect(() => {
    const destinationCountry = selectedHeader || "";
    const destination_city = selectedCity || "";
    const destination_port = selectedPort || "";
    const originCountryData =
      selectedValue?.length > 0
        ? selectedValue.map((ele) => ({
            origin_country: ele?.country,
            origin_city: ele?.selectedCity || ele?.city?.[0] || "",
            origin_port: ele?.selectedPort || ele?.port?.[0] || "",
            price_quotation_type: "",
            quotation: 0,
          }))
        : [];

    if (!destinationCountry || !destination_city || !originCountryData.length) {
      return;
    }

    const fetchData = async () => {
      try {
        const payload = {
          material_name: selectedMaterial?.material_name || "",
          hsn_code: selectedHSCode?.hsn_code
            ? selectedHSCode?.hsn_code
            : selectedHSCode?.hsncode
              ? selectedHSCode?.hsncode
              : "",
          currency_name: selectedCurrency.code,
          destination_country_data: [
            {
              destination_country: destinationCountry,
              destination_city,
              destination_port,
            },
          ],
          origin_country_data: originCountryData,
        };
        const response = await axiosInstance.post(
          "company/updated-master-period-list",
          payload,
        );
        setTimePeriod(response?.data?.data);
        const res = response?.data?.data?.filter((ele) => {
          return ele?.is_current;
        });

        // setSelectedTimePeriod(res[0] || {});
        setSelectedTimePeriod(response?.data?.data?.[0] || {});
      } catch (error) {}
    };
    fetchData();
  }, [
    selectedMaterial,
    selectedHSCode,
    selectedCurrency,
    selectedHeader,
    selectedCity,
    selectedPort,
    selectedValue,
  ]);

  useEffect(() => {
    const res = countryNames.reduce((acc, country) => {
      acc[country] = "";
      return acc;
    }, {});
    setExwValues(res);
  }, []);

  //matrix data get
  React.useEffect(() => {
    const abortController = new AbortController();
    const fetchData = async () => {
      try {
        const material_name = selectedMaterial?.material_name || "";
        const destinationCountry = selectedHeader || "";
        const destination_city = selectedCity || "";
        const destination_port = selectedPort || "";
        const originCountryData =
          selectedValue?.length > 0
            ? selectedValue.map((ele) => ({
                origin_country: ele?.country,
                origin_city: ele?.selectedCity || ele?.city?.[0] || "",
                origin_port: ele?.selectedPort || ele?.port?.[0] || "",
                price_quotation_type: "",
                quotation: 0,
              }))
            : [];

        const isPayloadValid =
          // material_name &&
          destinationCountry &&
          destination_city &&
          // destination_port &&
          originCountryData.length > 0;

        if (!isPayloadValid) {
          return;
        }

        const payload = {
          material_name,
          hsn_code: selectedHSCode?.hsn_code
            ? selectedHSCode?.hsn_code
            : selectedHSCode?.hsncode
              ? selectedHSCode?.hsncode
              : "",
          currency_name: selectedCurrency.code,
          master_period_id: selectedTimePeriod?.id
            ? selectedTimePeriod?.id
            : "",
          destination_country_data: [
            {
              destination_country: destinationCountry,
              destination_city,
              destination_port,
              // origin_city: "",
            },
          ],
          origin_country_data: originCountryData,
        };
        let response = [];
        if (!goButton) return;
        if (getLatest) {
          response = await axiosInstance.post(
            "company/bookmark/get-latest-material-matrix-detail-new",
            payload,
          );
          setGetLatestLoading(false);
        } else if (id == "" || id == null || id == undefined) {
          response = await axiosInstance.post(
            // "company/material-matrix-detail",
            "company/material-matrix-detail-new",
            payload,
          );
        } else {
          response = await axiosInstance.post(
            "company/bookmark/matrix-details",
            {
              id,
              currency_name: isFirstLoad.current ? "" : selectedCurrency?.code,
            },
            { signal: abortController.signal },
          );

          // ✅ mark first load as done only after this branch runs once
          if (isFirstLoad.current) {
            isFirstLoad.current = false;
          }
        }
        const apiCurrency = response?.data?.currency_name;

        if (apiCurrency && apiCurrency !== selectedCurrency?.code) {
          setSelectedCurrency({
            code: apiCurrency,
            currency_symbol: response?.data?.currency_symbol,
            country: response?.data?.country,
          });
        }
        const originData = response?.data?.data?.map((ele) => {
          return { ...ele.origin_cost_data, country: ele.origin_country };
        });

        //old data before checking euro country data
        // const originDestinations =
        //   groupedByOrigin[
        //     country?.charAt(0)?.toUpperCase() + country?.slice(1)
        //   ] || [];

        // const hasDestination = originDestinations
        //   .map((dest) => dest?.toLowerCase())
        //   .includes(selectedHeader?.toLowerCase());

        // const updatedData = {
        //   localLogistics: originData.map((item) => ({
        //     country: item.country,
        //     value: item.logistics_cost ?? 0,
        //   })),
        //   exportDuty: originData.map((item) => ({
        //     country: item.country,
        //     value: item.export_duty ?? 0,
        //   })),
        //   taxes: originData.map((item) => ({
        //     country: item.country,
        //     value: item.tax ?? 0,
        //   })),
        //   customClearance: originData.map((item) => ({
        //     country: item.country,
        //     value: item.origin_customs_clearance ?? 0,
        //   })),
        //   terminalHandling: originData.map((item) => ({
        //     country: item.country,
        //     value: item.origin_terminal_handling_charges ?? 0,
        //   })),
        // };

        const checkHasDestination = (origin, destination) => {
          const originKey = origin?.charAt(0)?.toUpperCase() + origin?.slice(1);
          const destinations = groupedByOrigin[originKey] || [];

          return destinations
            .map((dest) => dest?.toLowerCase())
            .includes(destination?.toLowerCase());
        };

        const updatedData = {
          localLogistics: originData.map((item) => {
            return {
              country: item.country,
              value:
                EXWValues[0][item.country] !== ""
                  ? (item.logistics_cost ?? 0)
                  : "N/A",
              //  !checkHasDestination(item.country, selectedHeader)
              //   ? item.logistics_cost ?? 0
              //   : 0,
            };
          }),

          exportDuty: originData.map((item) => ({
            country: item.country,
            value:
              EXWValues[0][item.country] !== ""
                ? from === "bookmark" && !getLatest
                  ? item?.export_duty
                  : ((EXWValues[0][item.country] * item.export_duty) / 100 ?? 0)
                : "N/A",
          })),

          taxes: originData.map((item) => ({
            country: item.country,
            value:
              EXWValues[0][item.country] !== ""
                ? from === "bookmark" && !getLatest
                  ? item?.tax
                  : ((EXWValues[0][item.country] * item?.tax) / 100 ?? 0)
                : "N/A",
          })),

          customClearance: originData.map((item) => ({
            country: item.country,
            value:
              EXWValues[0][item.country] !== ""
                ? (item.origin_customs_clearance ?? 0)
                : "N/A",
          })),

          terminalHandling: originData.map((item) => ({
            country: item.country,
            value:
              EXWValues[0][item.country] !== ""
                ? (item.origin_terminal_handling_charges ?? 0)
                : "N/A",
          })),
        };

        setData(updatedData);

        const oceanFreight = response?.data?.data?.map((ele) => {
          return { ...ele.ocean_freight_data, country: ele.origin_country };
        });

        const destinationData = response?.data?.data?.map((ele) => {
          return { ...ele.destination_cost_data, country: ele.origin_country };
        });
        const vatDataResponse = response?.data?.data?.map((ele) => {
          return { ...ele.vat_data, country: ele.origin_country };
        });
        setDestinationCountryData(destinationData);
        setOceanFreightData(oceanFreight);
        setVatData(vatDataResponse);
      } catch (error) {
        setGetLatestLoading(false);
      }
    };
    fetchData();
    return () => {
      abortController.abort();
    };
  }, [
    selectedHeader,
    selectedCity,
    selectedPort,
    selectedValue,
    selectedCurrency?.code,
    selectedTimePeriod,
    goButton,
    EXWValues,
    getLatest,
  ]);

  useEffect(() => {
    const countryNames =
      selectedValue && selectedValue.length > 0
        ? selectedValue.map((item) => item["country"])
        : [];
    setCountryUpdatedNames(countryNames);
    const cleanObject = (obj) => {
      for (let key in obj) {
        if (obj[key] === "" || obj[key] === undefined || obj[key] === null) {
          delete obj[key];
        }
      }
      return obj;
    };
    const cleanedFOB =
      FOBValues && FOBValues[0] ? cleanObject({ ...FOBValues[0] }) : {};
    const cleanedEXW =
      EXWValues && EXWValues[0] ? cleanObject({ ...EXWValues[0] }) : {};
    const cleanedCIF =
      CIFValues && CIFValues[0] ? cleanObject({ ...CIFValues[0] }) : {};
    const a = Object.keys(cleanedFOB);
    const b = Object.keys(cleanedEXW);
    const c = Object.keys(cleanedCIF);

    const d = [...a, ...b, ...c];

    if (!Array.isArray(countryNames)) {
      return;
    }

    const finalCountry = countryNames.filter((ele) => {
      if (!ele) {
        return false;
      }
      return d.includes(ele);
    });
    if (finalCountry.length === 0) {
    }
    setCountryNames(finalCountry);
  }, [selectedHeader, selectedRows, FOBValues, EXWValues]);

  useEffect(() => {
    if (Object.keys(FOBValues).length) {
      setFobTotals(FOBValues[0]);
    }
  }, [FOBValues]);

  useEffect(() => {
    if (Object.keys(EXWValues).length) {
      setExwValues(EXWValues[0]);
    }
  }, [EXWValues]);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Flatten nested array if needed
      const flatCityAndPort = CityAndPort.flat();

      const updatedValue =
        selectedValue &&
        selectedValue.map((item) => {
          const match = flatCityAndPort.find(
            (entry) => entry.country === item.country,
          );

          if (match && (item.city !== match.city || item.port !== match.port)) {
            return {
              ...item,
              city: match.city,
              port: match.port,
            };
          }

          return item;
        });

      const hasChanged = !isEqual(selectedValue, updatedValue);

      if (hasChanged) {
        // setSelectedValue(updatedValue);
        dispatch(updateDropDown(updatedValue));
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [CityAndPort, selectedValue]);

  const scrollTop = () => {
    // window.scrollTo(0, 0);
    window.scrollTo({ top: 0, behavior: "smooth" });
    // return mainViewRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: "smooth" });

  useEffect(() => {
    const columns = ["fob", "exw", "cif"];
    columns.forEach((column) => {
      if (!editingColumn[column]) {
        updateTotals(column);
      }
    });
  }, [data, countryNames]);

  const updateTotals = (column) => {
    if (column === "fob") {
      const newFobTotals = countryNames.reduce((acc, country) => {
        // if (exwValues[country]) {
        if (
          exwValues[country] !== undefined &&
          exwValues[country] !== null &&
          exwValues[country] !== ""
        ) {
          // if (data) {
          const fobValue = calculateFOB(country);
          acc[country] = fobValue;
          // }
        } else {
          acc[country] = fobTotals[country] || 0;
        }
        return acc;
      }, {});

      setFobTotals(newFobTotals);
    }
  };

  const calculateFOB = (country) => {
    if (!data && !exwValues[country]) return;

    const total =
      Object.keys(data).reduce((sum, type) => {
        if (country === selectedHeader) {
          return sum;
        }
        const itemValue =
          (data[type] || []).find((item) => item.country === country)?.value ||
          0;
        return sum + parseFloat(itemValue);
      }, 0) + (parseFloat(exwValues[country]) || 0);

    return parseFloat(total.toFixed(2));
  };

  const handleEditIconClick = (type) => {
    setData((prevData) => ({
      ...prevData,
      [type]: (prevData[type] || []).map((item) => ({
        ...item,
        value:
          tempEditData[type]?.find(
            (editItem) => editItem.country === item.country,
          )?.value || item.value,
        percentage:
          tempEditData[type]?.find(
            (editItem) => editItem.country === item.country,
          )?.updatedPercentage || item.updatedPercentage,
      })),
    }));
    updateTotals(type);
    setEditable((prev) => {
      const newEditableState = { ...prev, [type]: !prev[type] };
      if (type === "exw") {
        newEditableState["fob"] = false;
      } else if (type === "fob") {
        newEditableState["exw"] = false;
      }
      return newEditableState;
    });
  };

  const handleEdit = (type, country, value) => {
    setTempEditData((prevTempData) => ({
      ...prevTempData,
      [type]: (prevTempData[type] || []).some(
        (item) => item.country === country,
      )
        ? prevTempData[type].map((item) =>
            item.country === country
              ? {
                  ...item,
                  value,
                  updatedPercentage: (value / exwValues[country]) * 100,
                }
              : item,
          )
        : [...(prevTempData[type] || []), { country, value }],
    }));
  };

  const handleCityChange = (country, event) => {
    const newCity = event.target.value;
    const updated = selectedValue.map((item) =>
      item.country === country ? { ...item, city: newCity } : item,
    );

    const filtered = updated.filter((ele) =>
      countryNames.includes(ele.country),
    );

    dispatch(updateDropDown(filtered));
  };

  const handleCityPort = (country, event) => {
    const newPort = event.target.value;

    const updatedState = selectedValue.map((item) =>
      item.country === country ? { ...item, port: newPort } : item,
    );

    // Optional: filter only valid countries (if needed)
    const filtered = updatedState.filter((ele) =>
      countryNames.includes(ele.country),
    );

    // Dispatch directly to Redux
    dispatch(updateDropDown(filtered));
  };

  //city and port drop down before ui update
  // const getCitiesByCountry = (country) => {
  //   return [
  //     ...new Set(
  //       // dropDown.DropDown[0]

  //         .filter((item) => {
  //           return (
  //             item.Country &&
  //             item.Country.toLowerCase() === country.toLowerCase()
  //           );
  //         })
  //         .map((item) => item["Factory City"])
  //     ),
  //   ];
  // };

  // const getPortByCountry = (country) => {
  //   return [
  //     ...new Set(
  //       // dropDown.DropDown[0]

  //         .filter(
  //           (item) =>
  //             item.Country &&
  //             item.Country.toLowerCase() === country.toLowerCase()
  //         )
  //         .map((item) => item["Port City"])
  //         //added this line to filter out "Not Applicable" ports
  //         .filter((port) => port?.toLowerCase() !== "not applicable")
  //     ),
  //   ];
  // };

  // const handleReload = () => {
  //   calculateData();
  //   const res = countryNames.reduce((acc, country) => {
  //     acc[country] = "";
  //     return acc;
  //   }, {});

  //   setExwValues(res);
  //   setFobTotals(res);
  //   setEditable({
  //     loadingCharges: false,
  //     localLogistics: false,
  //     taxes: false,
  //     exportDuty: false,
  //     customClearance: false,
  //     terminalHandling: false,
  //     exw: true,
  //     fob: true,
  //   });
  //   if (childFunction) {
  //     childFunction();
  //   }
  //   setEditingColumn({});
  //   // window.location.href = "https://360.procurementresource.com/tariff-tool/";
  // };

  // const getPortByCountry = (country) => {

  //   return [
  //     ...new Set(

  //         .filter(
  //           (item) =>
  //             country && item.Country.toLowerCase() === country.toLowerCase()
  //         )
  //         .map((item) => {
  //           if (
  //             selectedHeader &&
  //             item.Country.toLowerCase() === selectedHeader.toLowerCase()
  //           ) {
  //             return item["Origin City"];
  //           } else {
  //             return item["Port City"];
  //           }
  //         })
  //     ),
  //   ];
  // };

  const renderTableRow = (type, label) => (
    <TableRow className={`${!showRow ? "" : "fade-row"}`}>
      <TableCell className={`row-height sticky-cell cell-height `}>
        <div className="align-main-cell">
          <span className="label_style">{label}</span>
          {editable[type] ? (
            <div>
              <div
                onClick={() => handleEditIconClick(type)}
                style={{
                  color: "#1850FF",
                  ...fontStyle,
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Save
              </div>
            </div>
          ) : (
            <div style={{ height: rowHeight + 2, textAlign: "center" }}>
              <div
                onClick={() => handleEditIconClick(type)}
                style={{
                  color: "#1850FF",
                  ...fontStyle,
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Edit
              </div>
            </div>
          )}
        </div>
      </TableCell>
      {countryNames.map((country, index) => {
        const matchingData = (data[type] || []).find(
          (dataItem) => dataItem.country === country,
        );

        const matchingData1 = (data[type] || []).filter(
          (dataItem) => dataItem.country === country,
        );
        return (
          <Tooltip
            key={index}
            placement="right"
            open={false}
            title={
              <ul
                style={{
                  margin: 0,
                  padding: "0 8px",
                  listStyleType: "disc",
                }}
              >
                Historical Value
                {matchingData1.length > 0 ? (
                  matchingData1.map((item, index) => {
                    return (
                      <li key={index}>
                        {
                          item.dateAndTime
                          // item["Origin Country"] === country ? "NA" : ""
                          //  : `: ${matchingData[type].dateAndTime}`
                        }
                        &nbsp;:&nbsp;{item.value}
                      </li>
                    );
                  })
                ) : (
                  <> {matchingData && matchingData["dateAndTime"]}</>
                )}
              </ul>
            }
          >
            <TableCell
              key={index}
              className="row-height cell-height"
              align="center"
            >
              {editable[type] &&
              editingColumn[country] !== "fob" &&
              (exwValues[country] !== undefined ||
                exwValues[country] !== "") ? (
                <TextField
                  variant="outlined"
                  size="small"
                  value={
                    tempEditData[type]?.find((item) => item.country === country)
                      ?.value !== undefined
                      ? tempEditData[type]?.find(
                          (item) => item.country === country,
                        )?.value
                      : matchingData
                        ? exwValues[country] === "" ||
                          exwValues[country] === undefined
                          ? ""
                          : matchingData.value
                        : "N/A"
                  }
                  onChange={(e) =>
                    handleEdit(type, country, e.target.value || "0")
                  }
                  sx={{
                    input: { textAlign: "center", border: "none" },
                    border: "none",
                  }}
                  InputProps={{
                    style: { height: rowHeight, padding: "0px" },
                  }}
                />
              ) : (
                <span
                  style={{
                    minHeight: `${rowHeight} !important`,
                    ...fontStyle,
                    fontWeight: 500,
                  }}
                >
                  {editable["fob"] && editingColumn[country] === "fob"
                    ? ""
                    : matchingData
                      ? exwValues[country] === "" ||
                        exwValues[country] === undefined
                        ? ""
                        : matchingData.country === selectedHeader
                          ? "N/A"
                          : `${parseFloat(matchingData.value).toFixed(1)}`
                      : exwValues[country] !== ""
                        ? "N/A"
                        : ""}
                </span>
              )}
            </TableCell>
          </Tooltip>
        );
      })}
      <TableCell className="row-height cell-height sticky-button"></TableCell>
    </TableRow>
  );

  function handleAddRow() {
    setShowRow(!showRow);
  }

  const getValueAndType = (country, sources) => {
    for (const [type, arr] of Object.entries(sources)) {
      const match = arr.find((obj) => {
        const val = obj[country];
        return val !== "" && val !== null && val !== undefined;
      });

      if (match) {
        return {
          country,
          type,
          value: match[country],
        };
      }
    }

    return {
      country,
      type: null,
      value: null,
    };
  };

  //origin country data for api payload
  const generateOriginCountryData = (
    countries,
    costData,
    freightData,
    vatUpdatedData,
    destinationCountryUpdatedData,
  ) => {
    return countries
      ? countries.map((entry) => {
          const country = entry.country;
          const getValue = (key) =>
            costData[key].find(
              (item) => item?.country?.toLowerCase() === country?.toLowerCase(),
            )?.value ?? 0;
          const freightDataValue = freightData.find(
            (ele) => ele?.Country?.toLowerCase() === country?.toLowerCase(),
          );
          const destinationValue = destinationCountryUpdatedData.find(
            (ele) => ele?.Country?.toLowerCase() === country?.toLowerCase(),
          );

          const vatValue = vatUpdatedData.find(
            (ele) => ele?.Country?.toLowerCase() === country?.toLowerCase(),
          );

          const valueType = getValueAndType(country, {
            CIF: CIFValues,
            FOB: FOBValues,
            EXW: EXWValues,
          });

          return {
            origin_country: country,
            origin_city: entry?.selectedCity || entry.city[0] || "",
            origin_port: entry?.selectedPort || entry.port[0] || "",
            price_quotation_type: valueType.type,
            quotation: valueType.value,
            currency_value: "USD",
            origin_cost_data: {
              logistics_cost: getValue("localLogistics"),
              origin_customs_clearance: getValue("customClearance"),
              origin_terminal_handling_charges: getValue("terminalHandling"),
              export_duty: getValue("exportDuty"),
              tax: getValue("taxes"),
              // origin_loading_charges: "",
            },
            ocean_freight_data: {
              ocean_freight_road_freight: freightDataValue?.Ocean_Freight,
              insurance: freightDataValue?.insurancePercentage,
              insuranceValue: freightDataValue?.insurance,
            },
            destination_cost_data: {
              additional_charges: destinationValue?.additionalCharges ?? 0,
              TariffPercentage: destinationValue?.TariffPercentage, //✅//
              tariff: destinationValue?.TariffValue,
              tariff_updated_value: destinationValue?.TariffValue,
              tariffValue: destinationValue?.Tariff,
              tariff_calculate_on: destinationValue?.calcOn, //✅
              other_charge_type: destinationValue?.otherChargesName, //✅
              other_charge_value: destinationValue?.otherChargesValue, //✅
              other_charge_calculated_value: destinationValue?.otherChargeValue,
              other_chage_calculate_on:
                destinationValue?.otherChargeCalculatedOn, //✅
              logistics_cost: destinationValue?.Logistic, //✅
              // destination_loading_charges: "",
              destination_customs_clearance: destinationValue?.CustomsClearance, //✅
              destination_terminal_handling_charges: destinationValue?.Terminal, //✅
            },
            vat_data: {
              vat: vatValue?.VAT,
              vatCalculated: vatValue?.VATValue,
            },
            // key_value: {
            //   EXW: 171.3,
            //   FOB: 190.4,
            //   CIF: 258.4,
            //   DDU: 289.4,
            //   DDP: 289.4,
            // },
          };
        })
      : [];
  };

  useEffect(() => {
    const origin_country_data = generateOriginCountryData(
      selectedValue,
      data,
      freightData,
      vatUpdatedData,
      destinationCountryUpdatedData,
    );

    const lowerCaseKeys = (obj = {}) =>
      Object.fromEntries(
        Object.entries(obj).map(([k, v]) => [k.toLowerCase(), v]),
      );

    // normalize once (important for performance)
    const exwValuesLC = lowerCaseKeys(exwValues);
    const fobTotalsLC = lowerCaseKeys(fobTotals);
    const CIFUpdateValueLC = lowerCaseKeys(CIFUpdateValue?.[0]);
    const DDUValuesLC = lowerCaseKeys(DDUValues?.[0]);
    const DDPValuesLC = lowerCaseKeys(DDPValues?.[0]);

    const originCountryData = countryNames.map((country) => {
      const data = origin_country_data.find(
        (item) => item.origin_country?.toLowerCase() === country.toLowerCase(),
      );

      if (!data) return null;

      const key = data.origin_country.toLowerCase();

      return {
        ...data, // 👈 original object
        key_value: {
          EXW: exwValuesLC[key] || "",
          FOB: fobTotalsLC[key] || "",
          CIF: CIFUpdateValueLC[key] || "",
          DDU: DDUValuesLC[key] || "",
          DDP: DDPValuesLC[key] || "",
        },
      };
    });

    // const originCountryData = countryNames.map((country) => {
    //   const data = origin_country_data.find(
    //     (item) => item.origin_country.toLowerCase() === country.toLowerCase()
    //   );
    //   return data || null;
    // });

    const payload = {
      material_name: selectedMaterial?.material_name || "",
      subcategory_id: selectedSubCategory?.id ? selectedSubCategory?.id : "",
      hsn_code: selectedHSCode?.hsncode ? selectedHSCode?.hsncode : "",
      destination_country_data: [
        {
          destination_country: selectedHeader || "",
          destination_city: selectedCity || "",
          destination_port: selectedPort || "",
          origin_city: "",
        },
      ],
      master_period_id: selectedTimePeriod?.id || "",
      origin_country_data: originCountryData,
      bookmark_title: "",
      currency_name: selectedCurrency?.code || "",
    };
    setApiPayload(payload);
  }, [
    selectedValue,
    data,
    freightData,
    CIFValues,
    FOBValues,
    CIFValues,
    selectedCurrency,
    destinationCountryUpdatedData,
  ]);

  const prioritizeSort = (arr, targetCountry) => {
    const priorityOrder = [
      (item) => item.country === targetCountry,
      (item) => item.code === "USD",
      (item) => item.code === "EUR",
      (item) => item.code === "CNY",
    ];

    return [...arr].sort((a, b) => {
      const aPriority = priorityOrder.findIndex((fn) => fn(a));
      const bPriority = priorityOrder.findIndex((fn) => fn(b));
      const aRank = aPriority === -1 ? Infinity : aPriority;
      const bRank = bPriority === -1 ? Infinity : bPriority;

      return aRank - bRank;
    });
  };

  async function getConvertedRate(from, to) {
    const payload = {
      fromCurrency: from,
      toCurrency: to,
      amount: 1,
    };

    try {
      const response = await axiosInstance.post(
        "company/convert-currency",
        payload,
      );
      const responseData = response?.data?.data;
      // const responseData = 2;
      // Update only one value for each country
      const updatedExw = { ...exwValues };
      const updatedFob = { ...FOBValues[0] };
      const updatedCif = { ...CIFValues[0] };

      for (const country of Object.keys(exwValues)) {
        const exw = exwValues[country];
        const fob = FOBValues[0][country];
        const cif = CIFValues[0][country];

        if (exw !== "" && exw != null) {
          updatedExw[country] = exw * responseData;
        } else if (fob !== "" && fob != null) {
          updatedFob[country] = fob * responseData;
        } else if (cif !== "" && cif != null) {
          if (country === "isValueFromHeader") continue;
          updatedCif[country] = cif * responseData;
        }
      }

      setExwValues(updatedExw);
      dispatch(updateFOB(updatedFob));
      dispatch(updateCIF(updatedCif));
      return responseData;
    } catch (error) {}
  }

  async function updateCurrency(value) {
    if (!value) return;
    setSelectedCurrency(value);

    if (prevCurrencyRef?.current?.code && value?.code) {
      const res = await getConvertedRate(
        prevCurrencyRef?.current?.code,
        value.code,
      );
      setCurrencyRate(res);
    }
    if (value) {
      prevCurrencyRef.current = value;
    }
  }

  const downloadExcel = async () => {
    // if (selectedMaterial?.material_name == null) return;
    // if (!selectedHSCode?.hsn_code  && !selectedMaterial?.material_name ) return;
    const updated_origin_country_data = apiPayload?.origin_country_data?.map(
      (item) => {
        const lowerCaseKeys = (obj) =>
          Object.fromEntries(
            Object.entries(obj || {}).map(([k, v]) => [k.toLowerCase(), v]),
          );
        const exwValuesLC = lowerCaseKeys(exwValues);
        const fobTotalsLC = lowerCaseKeys(fobTotals);
        const CIFUpdateValueLC = lowerCaseKeys(CIFUpdateValue[0]);
        const DDUValuesLC = lowerCaseKeys(DDUValues[0]);
        const DDPValuesLC = lowerCaseKeys(DDPValues[0]);
        return {
          ...item,
          EXW: exwValuesLC[item?.origin_country?.toLowerCase()] || "",
          FOB: fobTotalsLC[item?.origin_country?.toLowerCase()] || "",
          CIF: CIFUpdateValueLC[item?.origin_country?.toLowerCase()] || "",
          DDU: DDUValuesLC[item?.origin_country?.toLowerCase()] || "",
          DDP: DDPValuesLC[item?.origin_country?.toLowerCase()] || "",
        };
      },
    );

    const payload = {
      material_name: apiPayload.material_name || "",
      hsn_code: apiPayload.hsn_code || "",
      destination_country_data: apiPayload.destination_country_data || [],
      origin_country_data: updated_origin_country_data || [],
    };
    setLoadingExcel(true);
    // return
    try {
      const response = await axiosInstance.post(
        "company/export-material-matrix",
        payload,
        {
          responseType: "blob",
        },
      );

      const disposition = response.headers.get("Content-Disposition");
      let filename = "download.xlsx";
      if (disposition && disposition.includes("filename=")) {
        const matches = disposition.match(/filename="?(.+?)"?(\s*;|$)/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, filename);
      setLoadingExcel(false);
      // return response;
    } catch (error) {
      setLoadingExcel(false);
    }
  };

  const resetValues = () => {
    // navigate("/detail-view", {
    //   replace: true,
    //   state: {
    //     selectedRows: [],
    //     selectedHeader: selectedHeader,
    //     selectedMaterial: {
    //       material_name: selectedMaterial?.material_name,
    //     },
    //     id: "",
    //     from: "table",
    //   },
    // });
    setGetLatest(true);
    setGetLatestLoading(true);
  };

  useEffect(() => {
    setSelectedCurrency({
      country: "USA",
      code: "USD",
      rate: 1,
      currency_symbol: "$",
    });
    prevCurrencyRef.current = {
      country: "USA",
      code: "USD",
      rate: 1,
      currency_symbol: "$",
    };
  }, [isEditing]);

  return (
    <>
      <div>
        {open && (
          <Popup
            open={open}
            img={bookmark}
            usedFor="bookMarkCreate"
            material_name={selectedMaterial}
            handleClose={handleClose}
            redirectPath="/bookmark-data"
            title="Save to My Workspace"
            firstButton="Save and Go To My  Workspace"
            secondButton="Save and Continue Exploring"
            apiEndPoint="company/bookmark/create"
            payload={{
              ...apiPayload,
              hs_code_short_description:
                selectedHSCode?.hs_code_short_description,
            }}
            description="This is a dynamic modal opened on button click."
          />
        )}
      </div>
      <div>
        {openUpdateBookMark && (
          <Popup
            open={openUpdateBookMark}
            img={bookmarkIcon}
            usedFor="edit"
            material_name={selectedMaterial}
            handleClose={handleCloseUpdateBookmark}
            redirectPath="/bookmark-data"
            title="Do You Want To Overwrite Or Create New Entry For"
            firstButton="Create new"
            secondButton="Overwrite"
            apiEndPoint="company/bookmark/update"
            payload={{
              ...apiPayload,
              id: id,
            }}
            description="This is a dynamic modal opened on button click."
          />
        )}
      </div>

      {!goButton && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            mb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              px: 2.5,
              py: 1.3,
              borderRadius: "12px",
              background: "linear-gradient(90deg, #ff6a6a, #ff4d4d)",
              color: "#fff",
              fontWeight: 500,
              boxShadow: "0 10px 25px rgba(255, 77, 77, 0.35)",
              fontSize: "14px",
            }}
          >
            ⚠️ Please enter all the required details and click on <b>'Go'</b> to
            view the data.
          </Box>
        </Box>
      )}
      <Box sx={{ width: "100%", display: "flex" }}>
        <Grid
          container
          spacing={2}
          sx={{
            border: "none",
            borderRadius: "16px",
            margin: "12px 8px",
          }}
        >
          <Grid item lg={6} xs={12}>
            <Box
              sx={{
                ...cardBoxHeaderStyle,
              }}
            >
              <Card
                sx={{
                  ...cardStyle,
                }}
              >
                <CardHeader
                  title={`Ocean Freight vs Tariff (${selectedCurrency?.code}/MT) for Origin Countries`}
                  // subheader="Ocean Freight vs Tariff (%) for Origin Countries"
                  sx={{
                    ...cardHeaderStyle,
                    py: 1.25,
                    // opacity: 0.8,
                  }}
                  titleTypographyProps={{
                    // variant: "h2", // or use "body1", "body2" for smaller sizes
                    sx: {
                      ...cardHeaderStyle,
                      color: "#FFF",
                    },
                  }}
                />
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    paddingBottom: "2px !important",
                    paddingTop: "2px !important",
                  }}
                >
                  <BubbleChart
                    selectedHeader={selectedHeader}
                    selectedMaterial={selectedMaterial}
                    countryUpdatedNames={countryUpdatedNames}
                    selectedPort={selectedPort}
                    countryNames={countryNames}
                    selectedData={selectedValue}
                    fobTotals={fobTotals}
                    destinationCountryData={destinationCountryData}
                    oceanFreightData={oceanFreightData}
                    currency={selectedCurrency}
                  />
                </CardContent>
              </Card>
            </Box>
          </Grid>
          <Grid item lg={6} xs={12}>
            <Box
              sx={{
                ...cardBoxHeaderStyle,
              }}
            >
              <Card
                sx={{
                  ...cardStyle,
                }}
              >
                <CardHeader
                  // title="Landed Cost at Destination Country (USD/MT)"
                  title={`Landed Cost at Destination Country (${selectedCurrency?.code}/MT)`}
                  sx={{
                    ...cardHeaderStyle,
                    py: 1.25,
                    // opacity: 0.8,
                  }}
                  titleTypographyProps={{
                    sx: {
                      ...cardHeaderStyle,
                      color: "#FFF",
                    },
                  }}
                />
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <MapChart
                    selectedHeader={selectedHeader}
                    currency={selectedCurrency}
                  />
                </CardContent>
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    zIndex: 5,
                    paddingBottom: "5px",
                    width: "100%",
                    color: "var(--entered-text, #2C2C2E)",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    fontHeight: 500,
                    lineHeight: "normal",
                    letterSpacing: "-0.387px",
                  }}
                >
                  <div
                    style={{
                      ...mapFooterStyle,
                    }}
                  >
                    <div
                      style={{
                        ...footerItemMap,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <circle cx="10" cy="10" r="10" fill="#007F00" />
                      </svg>{" "}
                      &nbsp;Best sourcing location
                    </div>
                    <div
                      style={{
                        ...footerItemMap,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <circle cx="10.792" cy="10" r="10" fill="#4A4AFF" />
                      </svg>
                      &nbsp;Alternate sourcing locations
                    </div>
                    <div
                      style={{
                        ...footerItemMap,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <circle cx="10.1064" cy="10" r="10" fill="#936F00" />
                      </svg>
                      &nbsp;Destination country
                    </div>
                  </div>
                </Box>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <div
        style={{
          height: "auto",
          padding: "12px",
        }}
        // ref={myRef}
        ref={scrollToDownRef}
      >
        {goButton && (
          <>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <Box sx={{ p: 2, bgcolor: "#f9f9fb" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  {/* Currency Dropdown */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #e0e0e0",
                      borderRadius: 2,
                      px: 2,
                      py: 0,
                      bgcolor: "white",
                      width: "20vw",
                      // flex: 1,
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      value={selectedCurrency || null}
                      onChange={(event, newValue) => updateCurrency(newValue)}
                      options={currencyList || []}
                      isOptionEqualToValue={(option, value) =>
                        option?.code === value?.code
                      }
                      getOptionLabel={(option) =>
                        `${option.code} - ${
                          option.countryShort || option.country
                        }`
                      }
                      renderOption={(props, option) => {
                        const { key, ...otherProps } = props;
                        return (
                          <li
                            key={option?.code}
                            {...otherProps}
                            style={{ fontSize: "12px" }}
                          >
                            {`${option.code} - ${
                              option.countryShort || option.country
                            }`}
                          </li>
                        );
                      }}
                      renderInput={(params) => {
                        const selectedOption = currencyList.find(
                          (opt) => opt.code === selectedCurrency?.code,
                        );
                        const tooltipTitle = selectedOption
                          ? `${selectedOption.code} - ${
                              selectedOption.countryShort ||
                              selectedOption.country
                            }`
                          : "";
                        return (
                          <Tooltip title={tooltipTitle} arrow>
                            <TextField
                              {...params}
                              placeholder="Currency"
                              size="small"
                              sx={{
                                borderRadius: "12px",
                                minHeight: "20px",
                                "& .MuiInputBase-root": {
                                  padding: "0 0px",
                                  fontSize: "12px",
                                  minHeight: "20px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderRadius: "3px",
                                },
                                "& .MuiInputBase-input": {
                                  fontSize: "12px !important",
                                  padding: "0px 0 !important",
                                },
                              }}
                            />
                          </Tooltip>
                        );
                      }}
                      sx={{
                        width: "100%",
                        "& .MuiAutocomplete-option": {
                          fontSize: "10px",
                          minHeight: "10px",
                        },
                        "& .MuiAutocomplete-listbox": {
                          paddingTop: 0,
                          paddingBottom: 0,
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "8px",
                          fontSize: "11px",
                          minHeight: "20px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "8px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none !important", // 🚀 removes border
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none !important", // remove on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none !important", // remove on focus
                        },
                      }}
                    />
                  </Box>

                  {/* time period  Download Excel Button  */}
                  {/* Update Button */}

                  <Box
                    sx={{
                      // flex: 1,
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {id && (getLatest ? selectedTimePeriod?.period_name : timePeriodBookmark) && (
                      <span
                        style={{
                          display: "inline-block",
                          textAlign: "center",
                          backgroundColor: "#f3f0ff",
                          color: "#7c3aed",
                          fontWeight: 600,
                          fontSize: "14px",
                          padding: "6px 16px",
                          borderRadius: "20px",
                          marginRight: "12px",
                        }}
                      >
                        Time Period : {getLatest
                          ? (selectedTimePeriod?.period_name || "Latest")
                          : (typeof timePeriodBookmark === "string" ? timePeriodBookmark : JSON.stringify(timePeriodBookmark))}
                      </span>
                    )}
                    {id ? (
                      // <Button
                      //   variant="contained"
                      //   sx={{
                      //     textTransform: "none",
                      //     bgcolor: "#7c3aed",
                      //     "&:hover": { bgcolor: "#6b21a8" },
                      //     color: "white",
                      //     px: 4,
                      //   }}
                      //   onClick={resetValues}
                      // >
                      //   {true ? (
                      //     <CircularProgress size={20} sx={{ color: "white" }} />
                      //   ) : (
                      //     "Click here to update to latest data"
                      //   )}
                      // </Button>
                      <Button
                        variant="contained"
                        sx={{
                          textTransform: "none",
                          bgcolor: "#7c3aed",
                          "&:hover": { bgcolor: "#6b21a8" },
                          color: "white",
                          px: 4,
                        }}
                        onClick={resetValues}
                      >
                        <span
                          style={{
                            visibility: getLatestLoading ? "hidden" : "visible",
                          }}
                        >
                          Click here to update to latest data
                        </span>
                        {getLatestLoading && (
                          <CircularProgress
                            size={20}
                            sx={{
                              color: "white",
                              position: "absolute",
                              left: "50%",
                              transform: "translateX(-50%)",
                            }}
                          />
                        )}
                      </Button>
                    ) : (
                      <Autocomplete
                        size="small"
                        options={timePeriod}
                        value={selectedTimePeriod}
                        onChange={(event, newValue) =>
                          setSelectedTimePeriod(newValue)
                        }
                        getOptionLabel={(option) => option.period_name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            size="small"
                            sx={{
                              width: 150,
                              "& .MuiInputBase-root": {
                                height: 30,
                                minHeight: 30,
                                fontSize: "12px",
                              },
                              "& .MuiInputBase-input": {
                                padding: "4px 8px",
                                fontSize: "12px",
                              },
                            }}
                          />
                        )}
                        sx={{ marginRight: 1 }}
                      />
                    )}
                    {loadingExcel ? (
                      <CircularProgress
                        size={20}
                        sx={{ color: "blue", height: "100%", width: "100%" }}
                      />
                    ) : (
                      <IconButton
                        variant="contained"
                        onClick={() => downloadExcel()}
                        size="small"
                      >
                        <img src={excel} alt="Excel Icon" />
                      </IconButton>
                    )}
                  </Box>
                </Box>
              </Box>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  overflow: "auto",
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    height: "100%",
                    width: "100%",
                    overflow: "auto",
                    position: "relative",
                    borderRadius: 0,
                    // padding: "3px 10px",
                  }}
                >
                  <Table
                    sx={{
                      width: "100%",
                      textAlign: "left",
                      overflow: "auto",
                      height: "98%",
                      fontSize: "1px",
                      // borderCollapse: "separate",
                      // borderSpacing: 0,
                    }}
                  >
                    <TableHead sx={{ ...tableHeaderStyle }}>
                      <TableRow className="row-gap"></TableRow>
                      <TableRow className="row-height">
                        <TableCell className="row-height main-cell sticky-cell">
                          <span className="label_style">Country Of Origin</span>
                        </TableCell>
                        {countryNames.map((country, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              ...headerFontStyle,
                              ...fontStyle,
                              textAlign: "center",
                              background: "#2c0065",
                              color: "white",
                              lineHeight: "none",
                            }}
                          >
                            {country}
                          </TableCell>
                        ))}
                        <TableCell
                          className="row-height main-cell sticky-button"
                          // onClick={handleAddRow}
                        ></TableCell>
                      </TableRow>
                      {/* factory and city  */}

                      {/* <TableRow className="row-height">
                      <TableCell className="row-height sticky-cell cell-height header-width">
                        <span className="label_style">
                          Supplier Factory Location
                        </span>
                      </TableCell>
                      {countryNames.map((country, index) => {
                        const cities = getCitiesByCountry(country);
                        return (
                          <TableCell
                            key={index}
                            sx={{
                              // padding: "2px",
                              // ...headerFontStyle,
                              // ...fontStyle,
                              // height: rowHeight,
                              // textAlign: "center",
                              // borderRadius: 1,
                              padding: "2px",
                              height: rowHeight,
                              textAlign: "center",
                              verticalAlign: "middle",
                              // background: "#E8EBFB",
                              borderRadius: 1,
                            }}
                          >
                            <Select
                              variant="outlined"
                              size="small"
                              sx={{
                                height: rowHeight,
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .MuiSvgIcon-root": {
                                  color: "#2C003E",
                                },
                                "& .MuiSelect-select": {
                                  ...fontStyle,
                                  color: "#2C003E",
                                  paddingRight: "10px !important",
                                  textAlign: "center",
                                },
                              }}
                              value={
                                selectedValue.find(
                                  (item) =>
                                    item.country.toLowerCase() ===
                                    country.toLowerCase()
                                )?.city || ""
                              }
                              onChange={(e) => handleCityChange(country, e)}
                              fullWidth
                            >
                              {cities.map((city, idx) => (
                                <MenuItem key={idx} value={city}>
                                  {city}
                                </MenuItem>
                              ))}
                            </Select>
                          </TableCell>
                        );
                      })}
                      <TableCell className="row-height cell-height sticky-button"></TableCell>
                    </TableRow>
                    <TableRow className="row-height">
                      <TableCell className="row-height sticky-cell cell-height header-width">
                        <span className="label_style"> Origin Port</span>
                      </TableCell>
                      {countryNames.map((country, index) => {
                        const portCity = getPortByCountry(country);
                        return (
                          <TableCell
                            key={index}
                            sx={{
                              padding: "2px",
                              height: rowHeight,
                              textAlign: "center",
                              verticalAlign: "middle",
                              borderRadius: 1,
                            }}
                          >
                            <Select
                              variant="outlined"
                              size="small"
                              sx={{
                                height: rowHeight,
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .MuiSvgIcon-root": {
                                  color: "#2C003E",
                                },
                                "& .MuiSelect-select": {
                                  ...fontStyle,
                                  color: "#2C003E",
                                  paddingRight: "10px !important",
                                  textAlign: "center",
                                },
                              }}
                              value={
                                selectedValue.find(
                                  (item) =>
                                    item.country.toLowerCase() ===
                                    country.toLowerCase()
                                )?.port || ""
                              }
                              onChange={(e) => handleCityPort(country, e)}
                              fullWidth
                            >
                              {portCity.map((port, idx) => (
                                <MenuItem
                                  key={idx}
                                  value={port}
                                  // sx={{ fontFamily: "Lora" }}
                                >
                                  {port}
                                </MenuItem>
                              ))}
                            </Select>
                          </TableCell>
                        );
                      })}
                      <TableCell className="row-height cell-height sticky-button"></TableCell>
                    </TableRow> */}
                    </TableHead>
                    <TableBody>
                      <TableRow className="row-gap"></TableRow>
                      <TableRow className="row-height">
                        <TableCell className="row-height main-cell sticky-cell">
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span className="label_style">EXW</span>
                            {/* <span>($/MT)</span> */}
                            <span>
                              ({`${selectedCurrency?.currency_symbol}`}/MT)
                            </span>
                          </span>
                        </TableCell>
                        {countryNames.map((country, index) => (
                          <TableCell
                            key={index}
                            className={`row-height main-cell `}
                            align="center"
                          >
                            {/* <span>{exwValues[country]?.toFixed(1)}</span> */}
                            <span>
                              {typeof exwValues[country] === "number"
                                ? exwValues[country].toFixed(1)
                                : ""}
                            </span>
                          </TableCell>
                        ))}
                        <TableCell className="row-height main-cell sticky-button"></TableCell>
                      </TableRow>
                      <TableRow
                        className={`row-gap ${showRow ? "" : "fade-row"}`}
                      ></TableRow>
                      {renderTableRow("localLogistics", "Local Logistics")}
                      {renderTableRow("exportDuty", "Export Duty")}
                      {renderTableRow("taxes", "Taxes")}
                      {/* {renderTableRow("loadingCharges", "Loading Charges")} */}
                      {renderTableRow("customClearance", "Custom Clearance")}
                      {renderTableRow(
                        "terminalHandling",
                        "Origin Terminal Handling",
                      )}
                      <TableRow>
                        <TableCell className="row-height main-cell sticky-cell">
                          <span
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span className="label_style">FOB</span>
                            {/* <span>($/MT)</span> */}
                            <span>
                              ({`${selectedCurrency?.currency_symbol}`}/MT)
                            </span>
                          </span>
                        </TableCell>
                        {countryNames.map((country, index) => (
                          <TableCell
                            key={index}
                            // className="row-height main-cell"
                            className={
                              `row-height main-cell`
                              //    ${
                              //   index === countryNames.length - 1 ? "last-cell" : ""
                              // }`
                            }
                            align="center"
                          >
                            <span>
                              {fobTotals[country]
                                ? fobTotals[country].toString().includes(".")
                                  ? parseFloat(fobTotals[country]).toFixed(1)
                                  : fobTotals[country]?.toFixed(1)
                                : ""}
                            </span>
                          </TableCell>
                        ))}
                        {showRow ? (
                          <TableCell
                            className="row-height main-cell sticky-button"
                            onClick={handleAddRow}
                          >
                            +
                          </TableCell>
                        ) : (
                          <TableCell
                            className="row-height main-cell sticky-button"
                            onClick={handleAddRow}
                          >
                            -
                          </TableCell>
                        )}
                      </TableRow>

                      <FreightAndInsurance
                        selectedRows={selectedRows}
                        selectedHeader={selectedHeader}
                        selectedCity={selectedCity}
                        selectedPort={selectedPort}
                        fobData={fobTotals}
                        selectedData={selectedValue}
                        countryNames={countryNames}
                        oceanFreightData={oceanFreightData}
                        setFrightData={setFrightData}
                        currency={selectedCurrency}
                      />
                      <DestinationCountryCost
                        currencyRate={currencyRate}
                        selectedHeader={selectedHeader}
                        fobData={fobTotals}
                        countryNames={countryNames}
                        selectedOriginCity={selectedOriginCity}
                        destinationCountryData={destinationCountryData}
                        setDestinationCountryDataUpdatedData={
                          setDestinationCountryDataUpdatedData
                        }
                        from={from}
                        getLatest={getLatest}
                        currency={selectedCurrency}
                      />
                      <LocalTaxes
                        countryNames={countryNames}
                        vatData={vatData}
                        setVatUpdatedData={setVatUpdatedData}
                        currency={selectedCurrency}
                        from={from}
                      />
                      {false && (
                        <>
                          <TableRow>
                            <TableCell className="row-height main-cell-lead sticky-cell">
                              <span
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span className="label_style">Lead Time</span>
                                <span>($/MT)</span>
                              </span>
                            </TableCell>
                            {countryNames.map((country, index) => (
                              <TableCell
                                key={index}
                                className={`row-height main-cell-lead`}
                                align="center"
                              >
                                <span>lead time</span>
                              </TableCell>
                            ))}
                            <TableCell
                              className="row-height main-cell-lead sticky-button"
                              onClick={handleAddRow}
                            ></TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell className="row-height main-cell sticky-cell">
                              <span
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span className="label_style">
                                  Carbon Footprint
                                </span>
                                <span>($/MT)</span>
                              </span>
                            </TableCell>
                            {countryNames.map((country, index) => (
                              <TableCell
                                key={index}
                                className={`row-height main-cell`}
                                align="center"
                              >
                                <span>test</span>
                              </TableCell>
                            ))}

                            <TableCell
                              className="row-height main-cell sticky-button"
                              onClick={handleAddRow}
                            ></TableCell>
                          </TableRow>
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div style={{ ...footerStyle }}>
                  <Box
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row", lg: "row" }}
                    gap={1} // spacing between buttons
                    sx={{
                      width: "100%",
                      mt: 2,
                      justifyContent: "space-between",
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{
                        ...buttonStyle,
                        left: 0,
                      }}
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M17.4995 9.99986C17.4995 10.1656 17.4337 10.3246 17.3165 10.4418C17.1992 10.559 17.0403 10.6249 16.8745 10.6249H4.63311L9.1917 15.1827C9.24977 15.2407 9.29583 15.3097 9.32726 15.3855C9.35869 15.4614 9.37486 15.5427 9.37486 15.6249C9.37486 15.707 9.35869 15.7883 9.32726 15.8642C9.29583 15.94 9.24977 16.009 9.1917 16.067C9.13363 16.1251 9.0647 16.1712 8.98883 16.2026C8.91295 16.234 8.83164 16.2502 8.74952 16.2502C8.66739 16.2502 8.58608 16.234 8.5102 16.2026C8.43433 16.1712 8.3654 16.1251 8.30733 16.067L2.68233 10.442C2.62422 10.384 2.57812 10.3151 2.54667 10.2392C2.51521 10.1633 2.49902 10.082 2.49902 9.99986C2.49902 9.91772 2.51521 9.8364 2.54667 9.76052C2.57812 9.68465 2.62422 9.61572 2.68233 9.55767L8.30733 3.93267C8.4246 3.8154 8.58366 3.74951 8.74952 3.74951C8.91537 3.74951 9.07443 3.8154 9.1917 3.93267C9.30898 4.04995 9.37486 4.20901 9.37486 4.37486C9.37486 4.54071 9.30898 4.69977 9.1917 4.81705L4.63311 9.37486H16.8745C17.0403 9.37486 17.1992 9.44071 17.3165 9.55792C17.4337 9.67513 17.4995 9.8341 17.4995 9.99986Z"
                          fill="white"
                        />
                      </svg>
                      &nbsp; Back To Previous Page
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        if (from === "bookmark") {
                          handleOpenUpdateBookmark();
                        } else {
                          handleOpen();
                        }
                      }}
                      sx={{
                        ...buttonStyle,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M17.5603 3.75001L14.25 0.439695C14.1112 0.299801 13.946 0.188889 13.764 0.113407C13.582 0.0379245 13.3867 -0.000621974 13.1897 7.58902e-06H1.5C1.10218 7.58902e-06 0.720644 0.158043 0.43934 0.439347C0.158035 0.720652 0 1.10218 0 1.50001V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H16.5C16.8978 18 17.2794 17.842 17.5607 17.5607C17.842 17.2794 18 16.8978 18 16.5V4.81032C18.0006 4.61326 17.9621 4.41805 17.8866 4.23602C17.8111 4.054 17.7002 3.88879 17.5603 3.75001ZM12.75 16.5H5.25V11.25H12.75V16.5ZM16.5 16.5H14.25V11.25C14.25 10.8522 14.092 10.4707 13.8107 10.1893C13.5294 9.90804 13.1478 9.75001 12.75 9.75001H5.25C4.85218 9.75001 4.47064 9.90804 4.18934 10.1893C3.90804 10.4707 3.75 10.8522 3.75 11.25V16.5H1.5V1.50001H13.1897L16.5 4.81032V16.5ZM12 3.75001C12 3.94892 11.921 4.13969 11.7803 4.28034C11.6397 4.42099 11.4489 4.50001 11.25 4.50001H6C5.80109 4.50001 5.61032 4.42099 5.46967 4.28034C5.32902 4.13969 5.25 3.94892 5.25 3.75001C5.25 3.5511 5.32902 3.36033 5.46967 3.21968C5.61032 3.07903 5.80109 3.00001 6 3.00001H11.25C11.4489 3.00001 11.6397 3.07903 11.7803 3.21968C11.921 3.36033 12 3.5511 12 3.75001Z"
                          fill="white"
                        />
                      </svg>
                      &nbsp; Save To My Workspace
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => scrollTop()}
                      sx={{
                        ...buttonStyle,
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M16.0675 9.19219C16.0095 9.2503 15.9406 9.2964 15.8647 9.32785C15.7888 9.35931 15.7075 9.37549 15.6253 9.37549C15.5432 9.37549 15.4619 9.35931 15.386 9.32785C15.3101 9.2964 15.2412 9.2503 15.1832 9.19219L10.6253 4.6336V16.875C10.6253 17.0408 10.5595 17.1997 10.4423 17.3169C10.3251 17.4342 10.1661 17.5 10.0003 17.5C9.83459 17.5 9.67562 17.4342 9.55841 17.3169C9.4412 17.1997 9.37535 17.0408 9.37535 16.875V4.6336L4.81753 9.19219C4.70026 9.30947 4.5412 9.37535 4.37535 9.37535C4.2095 9.37535 4.05044 9.30947 3.93316 9.19219C3.81588 9.07492 3.75 8.91586 3.75 8.75C3.75 8.58415 3.81588 8.42509 3.93316 8.30782L9.55816 2.68282C9.61621 2.62471 9.68514 2.57861 9.76101 2.54715C9.83688 2.5157 9.91821 2.49951 10.0003 2.49951C10.0825 2.49951 10.1638 2.5157 10.2397 2.54715C10.3156 2.57861 10.3845 2.62471 10.4425 2.68282L16.0675 8.30782C16.1256 8.36586 16.1717 8.43479 16.2032 8.51067C16.2347 8.58654 16.2508 8.66787 16.2508 8.75C16.2508 8.83214 16.2347 8.91347 16.2032 8.98934C16.1717 9.06522 16.1256 9.13415 16.0675 9.19219Z"
                          fill="white"
                        />
                      </svg>{" "}
                      &nbsp; Back To Top
                    </Button>
                  </Box>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditableTable;
